import {
  INIT_SEGMENTS,
  START_SEGMENT_IMPRESSION,
  END_SEGMENT_IMPRESSION,
  VIDEO_PAUSE,
  VIDEO_PLAY,
  VIDEO_SEEK,
  SEGMENT_START,
  SEGMENT_FINISHED,
  PROGRESS_SECOND_UPDATE,
  VIDEO_FINISHED,
} from '../Actions/actionTypes';

const INIT_STATE = {};

const Video = (state = INIT_STATE, action) => {
  let videoState = state[action.moduleID];
  switch (action.type) {
    case INIT_SEGMENTS:
      let segments = videoState && videoState.segments ? videoState.segments : action.segments;

      let events = videoState && videoState.events ? videoState.events : [];
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          logID: action.info.logID,
          isPreviouslyCompleted: action.isVideoCompleted || videoState.isPreviouslyCompleted,
          isBuffered: action.info.buffer,
          lastSecondWatched: action.info.time,
          segments,
          content: {
            videoLength: action.info.length,
          },
          events: [
            ...events,
            {
              activity: 'BEGIN_PLAY',
              lastSecondWatched: 0,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case START_SEGMENT_IMPRESSION:
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          currentSegment: 'START',
          isPlaying: action.info.play,
          lastSeekTime: action.info.lastSeekTime,
          isBuffered: action.info.buffer,
          lastSecondWatched: action.info.time,
          events: [
            ...videoState.events,
            {
              activity: 'START_SEGMENT',
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case END_SEGMENT_IMPRESSION:
      let endState = {};
      endState.events = [
        ...videoState.events,
        {
          activity: 'END_SEGMENT',
          lastSecondWatched: action.info.time,
          buffer: action.info.buffer,
          lastSeekTime: action.info.lastSeekTime,
          timeStamp: new Date(),
        },
      ];
      if (action.info.lastSeekTime === 0) {
        endState = {
          endTimeStamp: new Date(),
          isCompleted: true,
          isPreviouslyCompleted: true,
          percentOfCompletion: 100,
          events: [
            ...endState.events,
            {
              activity: 'FINISHED',
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        };
      }
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          ...endState,
          currentSegment: 'END',
          isBuffered: action.info.buffer,
          isPlaying: action.info.play,
          lastSeekTime: action.info.lastSeekTime,
          lastSecondWatched: action.info.time,
        },
      };

    case VIDEO_PAUSE:
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          isPlaying: false,
          lastSeekTime: action.info.lastSeekTime,
          isBuffered: action.info.buffer,
          lastSecondWatched: action.info.time,
          events: [
            ...videoState.events,
            {
              activity: 'VIDEO_PAUSE',
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case VIDEO_PLAY:
      if (videoState === undefined) {
        return {
          ...state,
          [action.moduleID]: {
            ...videoState,
            isPlaying: true,
            lastSeekTime: 0,
            isPreviouslyCompleted: false,
            lastSecondWatched: 0,
            startTimeStamp: new Date(),
            percentOfCompletion: 0,
            events: [
              {
                activity: 'VIDEO_STARTED',
                lastSecondWatched: action.info.time,
                buffer: action.info.buffer,
                lastSeekTime: action.info.lastSeekTime,
                timeStamp: new Date(),
              },
            ],
          },
        };
      }
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          isPlaying: true,
          lastSeekTime: action.info.lastSeekTime,
          isBuffered: action.info.buffer,
          lastSecondWatched: action.info.time,
          events: [
            ...videoState.events,
            {
              activity: 'VIDEO_PLAY',
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case VIDEO_SEEK:
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          isPlaying: action.info.play,
          lastSeekTime: action.info.lastSeekTime,
          lastSecondWatched: action.info.time,
          events: [
            ...videoState.events,
            {
              activity: 'VIDEO_SEEK',
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case SEGMENT_START:
      let segmentStart = videoState.segments.map((seg, index) => {
        if (index === action.segmentIndex) {
          return {
            ...seg,
            startTimeStamp: seg.startTimeStamp || new Date(),
            currentTime: action.info.time,
          };
        }
        return seg;
      });
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          currentSegment: action.segmentDetails.segment,
          isPlaying: action.info.play,
          lastSeekTime: action.info.lastSeekTime,
          lastSecondWatched: action.info.time,
          segments: segmentStart,
          events: [
            ...videoState.events,
            {
              activity: `${action.segmentDetails.segment}_START`,
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case SEGMENT_FINISHED:
      let segmentEnd = videoState.segments.map((seg, index) => {
        if (index === action.segmentIndex) {
          return {
            ...seg,
            endTimeStamp: seg.endTimeStamp || new Date(),
            currentTime: action.info.time,
          };
        }
        return seg;
      });

      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          isPlaying: action.info.play,
          lastSeekTime: action.info.lastSeekTime,
          lastSecondWatched: action.info.time,
          segments: segmentEnd,
          events: [
            ...videoState.events,
            {
              activity: `${action.segmentDetails.segment}_END`,
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case PROGRESS_SECOND_UPDATE:
      let segmentProgress = videoState.segments.map((seg, index) => {
        if (index === action.segmentIndex) {
          return {
            ...seg,
            currentTime: action.info.time,
            percentOfCompletion: seg.isCompleted ? seg.percentOfCompletion : action.segmentDetails.percent,
            isCompleted: seg.isCompleted ? seg.isCompleted : action.segmentDetails.percent > 80,
          };
        }
        return seg;
      });

      let totalPercent = 0;

      videoState.segments.forEach((seg, index) => {
        if (index !== videoState.segments.length - 1) totalPercent += seg.percentOfCompletion;
      });

      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          isPlaying: action.info.play,
          lastSeekTime: action.info.lastSeekTime,
          lastSecondWatched: action.info.time,
          fullScreen: action.info.fullScreen,
          percentOfCompletion: videoState.isCompleted ? videoState.percentOfCompletion : totalPercent / (videoState.segments.length - 1),
          segments: segmentProgress,
          events: [
            ...videoState.events,
            {
              activity: `${action.segmentDetails.segment}_PROGRESS`,
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime,
              timeStamp: new Date(),
            },
          ],
        },
      };

    case VIDEO_FINISHED:
      return {
        ...state,
        [action.moduleID]: {
          ...videoState,
          isCompleted: true,
          isPreviouslyCompleted: true,
          isPlaying: action.info.playing,
          lastSeekTime: action.info.lastSeekTime ? action.info.lastSeekTime : '',
          lastSecondWatched: action.info.time,
          fullScreen: action.info.fullScreen,
          endTimeStamp: new Date(),
          events: [
            ...videoState.events,
            {
              activity: 'VIDEO_FINISHED',
              lastSecondWatched: action.info.time,
              buffer: action.info.buffer,
              lastSeekTime: action.info.lastSeekTime ? action.info.lastSeekTime : '',
              timeStamp: new Date(),
            },
          ],
        },
      };
    default:
      return state;
  }
};

export default Video;
